export const polygonRefs: google.maps.Polygon[] = [];
